import { render, staticRenderFns } from "./anim.vue?vue&type=template&id=3154f566&scoped=true&"
import script from "./anim.vue?vue&type=script&lang=js&"
export * from "./anim.vue?vue&type=script&lang=js&"
import style0 from "./anim.vue?vue&type=style&index=0&id=3154f566&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3154f566",
  null
  
)

export default component.exports